import React from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { BackgroundType, ChatItemBorder } from "@fidget/common/components/chat/chatItemBorder";
import styles from "./chatMessage.css";
import { MeetingSchedulerStatus } from "@fidget/common/models/meeting-scheduler-status";

interface Props {
  status: MeetingSchedulerStatus;
}

/**
 * Widget chat component that handles communicating current meeting scheduling
 * status to the user. Acts as a regular chat message sent by bot.
 */
export const ChatMeetingScheduler: React.SFC<Props> = ({ status }) => {
  const text = intl.formatMessage(
    status === MeetingSchedulerStatus.CANCELLED
      ? "conversation.meetingScheduler.botMessageCancelled"
      : "conversation.meetingScheduler.botMessage"
  );
  return (
    <ChatItemBorder widgetStyle backgroundType={BackgroundType.AGENT}>
      <div className={styles["message-body"]} dangerouslySetInnerHTML={{ __html: text }}></div>
    </ChatItemBorder>
  );
};
